import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { PaymentPageInfo } from '../types/paymentPageInfo'
import getPaymentPageInfo from '../api/getPaymentPageInfo'

const paymentPageLoader = async ({ params }: LoaderFunctionArgs): Promise<PaymentPageInfo> => {
    const { paymentPageId, method } = params

    const paymentPageInfo = await getPaymentPageInfo(paymentPageId!)

    // Редирект на результат, если платёж уже существует
    if (paymentPageInfo.existingPayment && !paymentPageInfo.reusable) {
        throw redirect(`/result/${paymentPageInfo.id}/${paymentPageInfo.existingPayment.id}`)
    }

    // Редирект на список методов, если выбран недоступный метод
    if (method && !paymentPageInfo.paymentMethodTypes.some(pm => pm.type === method)) {
        throw redirect(`/payment/${paymentPageInfo.id}`)
    }

    // Редирект на конкретный метод, если он единственный
    if (!method && paymentPageInfo.paymentMethodTypes.length === 1) {
        throw redirect(`/payment/${paymentPageInfo.id}/${paymentPageInfo.paymentMethodTypes[0].type}`)
    }

    return paymentPageInfo
}

export default paymentPageLoader
